<template>
  <el-dialog :title="$t('buildingForm.edit.title')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingForm.edit.buildingName')" prop="buildingName">
            <el-input v-model="form.buildingName" :placeholder="$t('buildingForm.edit.buildingNamePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingForm.edit.userName')" prop="userName">
            <el-input v-model="form.userName" :placeholder="$t('buildingForm.edit.userNamePlaceholder')" />
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('buildingForm.edit.userTel')" prop="userTel">
            <el-input v-model="form.userTel" :placeholder="$t('buildingForm.edit.userTelPlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('buildingForm.edit.statusCd')" prop="statusCd">
            <el-select v-model="form.statusCd" :placeholder="$t('buildingForm.edit.statusCdPlaceholder')" style="width:100%">
              <el-option :label="$t('buildingForm.status.valid')" value="0" />
              <el-option :label="$t('buildingForm.status.invalid')" value="1" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { getBuildingFormById, updateBuildingForm } from '@/api/oa/buildingFormApi'

export default {
  name: 'EditBuildingForm',
  data() {
    return {
      dialogVisible: false,
      form: {
        id: '',
        buildingName: '',
        userName: '',
        userTel: '',
        statusCd: '0',
        communityId: ''
      },
      rules: {
        buildingName: [
          { required: true, message: this.$t('buildingForm.validate.buildingNameRequired'), trigger: 'blur' },
          { max: 100, message: this.$t('buildingForm.validate.buildingNameMaxLength'), trigger: 'blur' }
        ],
        userName: [
          { required: true, message: this.$t('buildingForm.validate.userNameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('buildingForm.validate.userNameMaxLength'), trigger: 'blur' }
        ],
        userTel: [
          { required: true, message: this.$t('buildingForm.validate.userTelRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('buildingForm.validate.userTelFormat'), trigger: 'blur' },
          { max: 20, message: this.$t('buildingForm.validate.userTelMaxLength'), trigger: 'blur' }
        ],
        statusCd: [
          { required: true, message: this.$t('buildingForm.validate.statusCdRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.$nextTick(async () => {
        this.$refs.form && this.$refs.form.resetFields()
        await this.loadBuildingFormDetail(row.id)
      })
    },
    async loadBuildingFormDetail(id) {
      try {
        const data = await getBuildingFormById(id)
        this.form = { 
          ...data,
          communityId: getCommunityId()
        }
      } catch (error) {
        console.error('获取房产留资详情失败:', error)
        this.$message.error(this.$t('common.loadFailed'))
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.form.communityId = getCommunityId()
            await updateBuildingForm(this.form)
            this.$message.success(this.$t('common.operationSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('更新房产留资失败:', error)
            this.$message.error(this.$t('common.operationFailed'))
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
</style>